import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { colors } from '@src/styles';
import { ghostButtonSX, primaryButtonSX } from '../../scriptsStyles';

interface ModalActionsProps {
  onClose: () => void;
  onTrigger: () => void;
  isLoading?: boolean;
  isAlreadyTriggered?: boolean;
}

export const ModalActions = ({ onClose, onTrigger, isLoading, isAlreadyTriggered }: ModalActionsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        justifyContent: 'flex-end',
        px: 3,
        py: 1.75,
        flexShrink: 0,
        borderTop: `1px solid ${colors.brand.line}`,
      }}
    >
      <Button variant="outlined" onClick={onClose} sx={ghostButtonSX}>
        Fechar
      </Button>
      <Tooltip title={isAlreadyTriggered ? 'Esta action já foi disparada ou está em andamento' : ''} arrow>
        <span>
          <Button
            variant="contained"
            disableElevation
            onClick={onTrigger}
            disabled={isLoading || isAlreadyTriggered}
            startIcon={isLoading ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : <SendRoundedIcon />}
            sx={primaryButtonSX}
          >
            {isLoading ? 'Disparando…' : 'Disparar'}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};
